import { removeSessionStorageValue, SERVICE_FLOW_STORAGE_KEYS } from '../storage';

const SUBMIT_ACTION_REDIRECT = 'redirect';

function buildItem(item) {
  const li = document.createElement('li');
  li.className = 'submit-dialog__item';

  const imagePlaceholder = document.createElement('div');
  imagePlaceholder.className = 'submit-dialog__item-image-placeholder';

  if (item.imageUrl && item.imageUrl.trim() !== '') {
    const img = document.createElement('img');
    img.className = 'submit-dialog__item-image';
    img.src = item.imageUrl;
    img.alt = item.productName || '';

    img.addEventListener('error', () => {
      img.remove();
      imagePlaceholder.classList.add('submit-dialog__item-image-placeholder--empty');
    });

    imagePlaceholder.appendChild(img);
  } else {
    imagePlaceholder.classList.add('submit-dialog__item-image-placeholder--empty');
  }

  li.appendChild(imagePlaceholder);

  const details = document.createElement('div');
  const title = document.createElement('div');
  title.className = 'submit-dialog__item-title';
  title.textContent = item.productName || '';
  const serialNo = document.createElement('p');
  serialNo.className = 'submit-dialog__item-serial';
  serialNo.textContent = item.serialNo || '';
  details.append(title, serialNo);
  li.appendChild(details);

  return li;
}

function openDialog(items) {
  const dialog = document.querySelector('[data-submit-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const list = dialog.querySelector('[data-submit-dialog-items]');
  if (list) {
    list.replaceChildren(...items.map(buildItem));
  }

  if (!dialog.dataset.submitDialogBound) {
    dialog.dataset.submitDialogBound = 'true';

    // The request is already submitted - the user has to pick one of the actions.
    dialog.addEventListener('cancel', (event) => event.preventDefault());
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    });
  }

  dialog.showModal();
}

// Post-submit behaviour is decided by the backend (SubmitAction in the config):
//   redirect   - Return: go straight to the confirmation page
//   cartDialog - Repair/Remake/LossAndDamage/ReplaceReceivers: modal with "go to cart" + "make another request"
//   dialog     - Extend/Register: modal with "make another request" only
export function handleSubmitSuccess(warrantyConfig, items) {
  removeSessionStorageValue(SERVICE_FLOW_STORAGE_KEYS.ITEMS);

  if (warrantyConfig?.SubmitAction === SUBMIT_ACTION_REDIRECT) {
    const confirmationUrl = warrantyConfig?.ConfirmationUrl;

    if (confirmationUrl) {
      window.location.href = confirmationUrl;
      return true;
    }
    return false;
  }

  openDialog(items);
  return false;
}
